/**
 * Remember that these values show up in our logs
 * Make sure the enum values are unique
 * Once we ship a feature flag, we can't change the key.
 */
export enum FlagKey {
  /** Which countries should be blocked for Funkit Checkout. Reference Alpha-2 Code format https://www.iban.com/country-codes. */
  BlockedCountries = 'blocked_countries',
  /** Which users/addresses should be blocked for Funkit Checkout */
  AddressBlacklist = 'address_blacklist',
  /** @deprecated Moved to statsig - Whether to show the [Powered by Fun.xyz] tagline at the bottom of the checkout modal. */
  ShowPoweredTagline = 'show_powered_tagline',
  /** Whether to enable Token Transfer as a payment method. */
  EnableTokenTransfer = 'enable_token_transfer',
  /** Token Transfer payment method accepted source chain and assets */
  TokenTransferSourceChainsAndAssets = 'token_transfer_source_chains_and_assets',
  /** Token Transfer universal deposit address */
  EnableTokenTransferUniversalDepositAddress = 'enable_token_transfer_universal_deposit_address',
  /** Maximum usd amount that can be checked out. */
  MaxCheckoutUsd = 'max_checkout_usd',
  /** Time estimate overrides */
  CheckoutTimeEstimateOverrides = 'checkout_time_estimate_overrides',
  /** Default chain ID used in Token transfer (Direct deposit) screen */
  TokenTransferDefaultChainId = 'token_transfer_default_chain_id',
  /** Set default token(s) in dropdown - prioritized in sorted list */
  TokenTransferDefaultTokens = 'token_transfer_default_tokens',
  /** Controls whether the checkout is activated or totally disabled */
  IsCheckoutActivated = 'is_checkout_activated',
  /** @deprecated Moved to statsig */
  ShowInfoBanner = 'show_info_banner',
  /** Controls refresh interval to show the checkout notifications */
  CheckoutNotificationsRefreshInterval = 'checkout_notifications_refresh_interval',
  /** Tokens for which to show the "New" badge in transfers */
  TokenTransferNewTokens = 'token_transfer_new_tokens',
  /** Whether to show the Newly supported deposits banner in asset selection */
  NewTokenAssetSelectionBanner = 'new_token_asset_selection_banner',
  /** @deprecated Moved to Statsig - Whether Relay bypass is enabled */
  IsRelayBypassEnabled = 'is_relay_bypass_enabled',
  /** Relay bypass accepted source chain and assets */
  RelayBypassSourceChainsAndAssets = 'relay_bypass_source_chains_and_assets',
  /** Relay bypass accepted target chain and assets */
  RelayBypassTargetChainsAndAssets = 'relay_bypass_target_chains_and_assets',
  EnableFiatDeposit = 'enable_fiat_deposit',
  /** @deprecated */
  EnableCard = 'enable_card',
  /** @deprecated */
  EnableBrokerage = 'enable_brokerage',
  EnableBluvoBrokerage = 'enable_bluvo_brokerage',
  /** Whether to use Meld as card payment */
  EnableMeldPayment = 'enable_meld_payment',
  MeldQuickOptions = 'meld_quick_options',
  /** Specifies the minimum value permitted for a token transfer. */
  MinTokenTransferValue = 'min_token_transfer_value',
  /** Exclude certain tokens from withdrawal. */
  WithdrawalExcludeTokens = 'withdrawal_exclude_tokens',
  /** Accepted chains and assets for withdrawal */
  WithdrawalChainsAndAssets = 'withdrawal_chains_and_assets',
  /** Chain ID sort order */
  ChainIdSortOrder = 'chain_id_sort_order',
  /** Whether to enable Bitcoin as a payment method. */
  EnableBitcoin = 'enable_bitcoin',
  /** Renders info banners for the currently selected chain */
  ChainInfoBanners = 'chain_info_banners',
  /** @deprecated */
  Permit2Tokens = 'permit2_tokens',
}
